import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import { LazyServices, LazyRentals, LazyPrivacy, LazyLoadErrorBoundary, LoadingFallback } from './components/LazyComponents';
import { updatePageSEO } from './utils/seo';

const NotFoundPage = () => (
  <Box 
    sx={{ 
      display: 'flex',
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      px: 2
    }}
  >
    <Typography variant="h1" component="h1" sx={{ fontSize: '4rem', mb: 2 }}>
      404
    </Typography>
    <Typography variant="h4" component="h2" sx={{ mb: 2 }}>
      Page Not Found
    </Typography>
    <Typography variant="body1">
      The page you're looking for doesn't exist. Return to our{' '}
      <a href="/" style={{ color: 'inherit', textDecoration: 'underline' }}>
        homepage
      </a>{' '}
      to explore our trucking services.
    </Typography>
  </Box>
);

const AppContent = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Update SEO data when route changes
    updatePageSEO(location.pathname);
  }, [location.pathname]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <main style={{ flex: 1 }}>
        <LazyLoadErrorBoundary>
          <Suspense fallback={<LoadingFallback message="Loading page..." />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<LazyPrivacy />} />
              <Route path="/services" element={<LazyServices />} />
              <Route path="/rentals" element={<LazyRentals />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </LazyLoadErrorBoundary>
      </main>
      <Footer />
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
